import { makeStyles } from '@material-ui/core/styles';

const DATE_SPACING = '85px';
const ATTACHMENT_SPACING = '30px';
const EMAIL_ITEM_HEIGHT = 100;

export const useStyles = makeStyles(theme => ({
  aiText: {
    margin: ({ hasWarning }) => (hasWarning ? theme.spacing(1, 0, 0, 0) : theme.spacing(1, 0)),
    color: 'transparent',
    background: 'linear-gradient(160deg, #767ef5 0%, #db6ffc 100%)',
    '-webkit-background-clip': 'text',
    fontWeight: 700
  },
  chipSpacing: {
    margin: theme.spacing(1, 0, 0)
  },
  emailItem: {
    width: '100%',
    minHeight: EMAIL_ITEM_HEIGHT,
    borderBottom: `1px solid ${theme.palette.customColors.lightgrey} `,
    padding: theme.spacing(1, 2),
    cursor: 'pointer',
    overflow: 'hidden',
    '&:hover': {
      backgroundColor: theme.palette.customColors.lightButtonHover
    },
    '& > *': {
      maxWidth: '100%'
    }
  },
  activeCard: {
    backgroundColor: theme.palette.customColors.linkWater
  },
  emailSearchProjectName: {
    fontSize: 16,
    maxWidth: `calc(100% - ${DATE_SPACING})`,
    fontWeight: 700,
    color: theme.palette.customColors.black
  },
  emailDate: {
    color: theme.palette.customColors.lightText
  },
  previewText: {
    maxWidth: ({ hasAttachments }) => (hasAttachments ? `calc(100% - ${ATTACHMENT_SPACING})` : '')
  },
  warningContainer: {
    padding: theme.spacing(1, 0, 0)
  },
  warningIcon: {
    marginRight: theme.spacing(1)
  }
}));
